
import {get} from "@insite/client-framework/Services/ApiService";

export function getIReceivableURL(date:string): Promise<string> {
        const getAccountModel = get<string>(`api/v1/ireceivable?date=${ date}`);
        return getAccountModel;
}

